/**
 * Cookie `ik_profession`: la professione scelta dall'utente nel catalogo (box
 * "Seleziona la tua professione"). Un anno, leggibile anche dal server.
 * Valore JSON: { slug, id (professione), discipline (id o null), at }.
 * Serve a personalizzare catalogo, registrazione e lista d'attesa prima ancora
 * che l'utente abbia un account.
 */
const NAME = 'ik_profession';
const TTL_S = 365 * 24 * 60 * 60;

export function saveProfession(slug, occupationId, disciplineId) {
    const value = JSON.stringify({ slug, id: occupationId || null, discipline: disciplineId || null, at: Date.now() });
    document.cookie = NAME + '=' + encodeURIComponent(value)
        + '; path=/; max-age=' + TTL_S + '; SameSite=Lax'
        + (location.protocol === 'https:' ? '; Secure' : '');
}

/** L'utente non vuole il filtro: per gli ospiti il cookie sparisce, per chi e' loggato
 *  (professione nel profilo) resta un cookie "all" che dice al server di non filtrare. */
export function clearProfession(keepAllMarker = false) {
    if (keepAllMarker) {
        saveProfession('all', null, null);
        return;
    }
    document.cookie = NAME + '=; path=/; max-age=0; SameSite=Lax';
}

export function readProfession() {
    try {
        const raw = document.cookie.split('; ').find(c => c.startsWith(NAME + '='));
        if (!raw) return null;
        const data = JSON.parse(decodeURIComponent(raw.slice(NAME.length + 1)));
        if (!data || !data.slug || data.slug === 'all') return null;
        return { slug: String(data.slug), id: data.id ? Number(data.id) : null, discipline: data.discipline ? Number(data.discipline) : null };
    } catch (e) {
        return null;
    }
}
